import React, { useState } from 'react'
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ScoreCard from './scoreCard';
import InnovationGrading from './innovationGrading';
import WealthGeneration from './wealthGeneration';
import EemploymentCreation from './employmentCreation';
import './index.scss';
import { updateSaveView80iac } from '../dependencies/action';
import { get80IACApplicationDetails } from '../../dependencies/action';
import { ROLES } from '../../../../constants/Roles'
import { storage } from '../../../../dependencies/store/storage';
function PartialView(props) {
  const dispatch = useDispatch();
  const scoreCardsAdminScores = {
    creditRatingScore: props?.data?.ScoreCard?.score?.adminScore?.creditRatingScore || null,
    scalabilityScore: props?.data?.ScoreCard?.score?.adminScore?.scalabilityScore || null,
    totalGroupCredit: props?.data?.ScoreCard?.score?.adminScore?.totalGroupCredit || 0,
  };
  const innovationsGradings = {
    intellectualProperty: props?.data?.ScoreCard?.score?.adminScore?.intellectualProperty || null,
    achievementsAwards: props?.data?.ScoreCard?.score?.adminScore?.achievementsAwards || null,
    stageOfProductService: props?.data?.ScoreCard?.score?.adminScore?.stageOfProductService || null,
    employmentOfResearchPersonnel: props?.data?.ScoreCard?.score?.adminScore?.employmentOfResearchPersonnel || null,
    // totalGroup1Score: props?.data?.ScoreCard?.score?.adminScore?.totalGroup1Score || 0,

  }
  const wealthsGeneration = {
    fundingObtained: props?.data?.ScoreCard?.score?.adminScore?.fundingObtained || 0,
    revenueGeneration: props?.data?.ScoreCard?.score?.adminScore?.revenueGeneration || null,
    profitability: props?.data?.ScoreCard?.score?.adminScore?.profitability || null,
    totalGroup2Score: props?.data?.ScoreCard?.score?.adminScore?.totalGroup2Score || 0,
  }
  const employmentsCreation = {
    directEmployment: props?.data?.ScoreCard?.score?.adminScore?.directEmployment || 0,
    pwdFemaleEmploymentCount: props?.data?.ScoreCard?.score?.adminScore?.pwdFemaleEmploymentCount || 0,
    employmentTierAndCities: props?.data?.ScoreCard?.score?.adminScore?.employmentTierAndCities || 0,
    totalGroup3Score: props?.data?.ScoreCard?.score?.adminScore?.totalGroup3Score || 0,
  }
  const [scoreCardAdminScores, setScoreCardAdminScores] = useState(scoreCardsAdminScores);
  const [innovationGradingAdminScores, setInnovationGradingAdminScores] = useState(innovationsGradings);
  const [wealthGeneration, setWealthGeneration] = useState(wealthsGeneration);
  const [employmentCreation, setEmploymentCreation] = useState(employmentsCreation);

   const userRole = storage.getUserRole();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {

      // id: props?.data?.ScoreCard?.score?.id,
      formId: props?.sAppId,
      // incorporationNumber: props?.data?.ScoreCard?.score?.incorporationNumber,
      ...scoreCardAdminScores,
      ...innovationGradingAdminScores,
      ...wealthGeneration,
      ...employmentCreation,
    };

    try {
      dispatch(updateSaveView80iac(payload)).then(res => {
        setTimeout(() => {
          dispatch(get80IACApplicationDetails(props?.sAppId));
        }, 1000);
      })
      
    } catch (error) {
      // toast.error("An unexpected error occurred.");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <ScoreCard data={props?.data} adminScores={scoreCardAdminScores} setAdminScores={setScoreCardAdminScores} />
        <InnovationGrading data={props?.data} adminScores={innovationGradingAdminScores} setAdminScores={setInnovationGradingAdminScores} />
        <WealthGeneration data={props?.data} adminScores={wealthGeneration} setAdminScores={setWealthGeneration} />
        <EemploymentCreation data={props?.data} adminScores={employmentCreation} setAdminScores={setEmploymentCreation} />

        <div className="save-total">
          <div className="row mb-20">
            <div className="col-12 d-flex justify-content-end">
              {(userRole === 'SUPER_ADMIN' || userRole === 'ADMIN')  && (
              <button type="submit">SAVE</button>)}
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-30">
              <table>
                <tbody>
                  <tr>
                    <td className="totale-marks">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <h6>Total SIH User Marks</h6>
                            </td>
                            <td>{props?.data?.ScoreCard?.score?.sihScore?.totalScore}</td>
                            <td>Total Admin Marks</td>
                            <td>{props?.data?.ScoreCard?.score?.adminScore?.totalScore}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default PartialView;
